@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    @if (listValues$ | async; as values) {
        @if (values.length > 0) {
            <dd class="sh-description-list__details">
                @if (childDefinition) {
                    @switch (childDefinition?.Type) {
                        @case (FieldType.EnumField) {
                            <ng-container *ngTemplateOutlet="labelList; context: { values: values, childDefinition: childDefinition }"></ng-container>
                        }
                        @default {
                            <ng-container *ngTemplateOutlet="tagList; context: { values: values, childDefinition: childDefinition }"></ng-container>
                        }
                    }
                }
            </dd>
        } @else {
            <dd class="sh-description-list__details">-</dd>
        }
    } @else {
        <dd class="sh-description-list__details">-</dd>
    }
} @else {
    <dd class="sh-description-list__details">-</dd>
}

<ng-template #labelList let-values="values" let-childDefinition="childDefinition">
    <ng-container
        *ngTemplateOutlet="
            canSearchOnClick(childDefinition) ? searchableListItems : nonSearchableListItems;
            context: { values: values, childDefinition: childDefinition }
        "
    ></ng-container>
</ng-template>

<ng-template #searchableListItems let-values="values" let-childDefinition="childDefinition">
    @for (option of values; track option; let index = $index) {
        <span>
            <a class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(childDefinition, option.value)">{{ option.label }}</a>
            @if (index < values.length - 1) {
                ,
            }
        </span>
    }
</ng-template>

<ng-template #nonSearchableListItems let-values="values">
    @for (option of values; track option; let index = $index) {
        <span>
            {{ option.label }}
            @if (index < values.length - 1) {
                ,
            }
        </span>
    }
</ng-template>

<ng-template #tagList let-values="values" let-childDefinition="childDefinition">
    <ul class="sh-tag-list sh-clear-margin-top">
        <ng-container
            *ngTemplateOutlet="
                canSearchOnClick(childDefinition) ? searchableTags : nonSearchableTags;
                context: { values: values, childDefinition: childDefinition }
            "
        ></ng-container>
    </ul>
</ng-template>

<ng-template #searchableTags let-values="values" let-childDefinition="childDefinition">
    @for (keyword of values; track keyword) {
        <a class="sh-tag--link sh-tag-list__item" [title]="keyword.label">
            <span class="sh-tag__label" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(childDefinition, keyword.value)">{{
                keyword.label
            }}</span>
        </a>
    }
</ng-template>

<ng-template #nonSearchableTags let-values="values" let-childDefinition="childDefinition">
    @for (keyword of values; track keyword) {
        @switch (childDefinition?.Type) {
            @case (FieldType.UrlField) {
                <a class="sh-tag--link sh-tag-list__item" [href]="keyword.value" target="_blank" rel="noopener noreferrer" [title]="keyword.label">
                    <span class="sh-tag__label">{{ keyword.label }}</span>
                </a>
            }
            @default {
                <li class="sh-tag--readonly sh-tag-list__item" [title]="keyword.label">
                    <span class="sh-tag__label">{{ keyword.label }}</span>
                </li>
            }
        }
    }
</ng-template>
